"use client"

import { Videotape } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `VideotapeIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const VideotapeIcon = component(Icon)({ as: Videotape })
